import { NEXT_PUBLIC_IMAGE_URL } from '@/common';
import { ITestimonial } from '@/types';

export const testimonials: ITestimonial[] = [
  {
    name: 'Hoàng Vy',
    role: 'SV ngành Thương Mại Điện Tử, ĐH Công nghiệp',
    message: `Việc tìm được một nền tảng như Upzi giúp mình dễ dàng xây dựng thương hiệu cá nhân, kết nối với nhà tuyển dụng uy tín và có lộ trình phát triển rõ ràng. Mình thật sự biết ơn vì sự hỗ trợ thiết thực mà Upzi mang lại cho sinh viên.`,
    avatar: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/hoang_vy.jpg`,
  },
  {
    name: 'Đình Trung',
    role: 'SV năm 3, Đại học Ngoại thương TPHCM',
    message: `Khi biết đến Upzi, mình đã rất bất ngờ vì những tính năng app cung cấp rất hữu dụng đối với sinh viên năm 3 như mình. Upzi giúp mình định hướng công việc, tìm hiểu về các ngành nghề, tìm việc phù hợp và đặc biệt mình rất thích tính năng học tập khi app cung cấp lộ trình, tài liệu, video phù hợp giúp mình học tốt hơn`,
    avatar: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/dinh_trung.jpg`,
  },
  {
    name: 'Xuân Nghi',
    role: 'SV năm 4, trường Đại học Văn Lang',
    message: `Upzi - một mentor thực thụ. Giúp mình hiểu rõ mình phù hợp ngành nghề nào, làm gì, học gì, học ở đâu và trở thành ai trong tương lai. Giải đáp muôn vàn câu hỏi suốt thời sinh viên. Chỉ ước gặp Upzi sớm hơn để vững bước hơn trên hành trình sự nghiệp! ^^`,
    avatar: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/xuan_nghi.jpg`,
  },
  {
    name: 'Anh Thư',
    role: 'Customer Experience Intern tại Navigos Group',
    message: `Upzi dễ dùng, hợp gu Gen Z tụi mình, đặc biệt là có tính năng đánh giá mức độ phù hợp giữa kinh nghiệm cá nhân và yêu cầu của công việc, giúp mình tự tin hơn khi ứng tuyển. Xịn sò thua Doraemon mỗi cái túi thần kỳ thôi chứ mở app là thấy thắng đời 1-0 liền á.`,
    avatar: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/anh_thu.jpg`,
  },
  {
    name: 'Hồng Phúc',
    role: 'Data Management Executive tại Metub',
    message: `Với mình, Upzi là ứng dụng toàn diện nhất cho bạn 1 bạn trẻ đang mông lung về định hướng tương lai. Ứng dụng cung cấp đầy đủ mọi yếu tố cần thiết cho hành trình nghề nghiệp: tin tuyển dụng uy tín, các khóa học nâng cao chuyên môn và gợi ý lộ trình phát triển sự nghiệp bằng AI`,
    avatar: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/hong_phuc.jpg`,
  },
  {
    name: 'Thiên Ân',
    role: 'Junior Strategic Planner',
    message: `Không phải con đường sự nghiệp nào cũng thẳng tắp và theo chiều tuyến tính - mình đã phải đi qua nhiều khúc quanh để biết mình là ai và mình thật sự thuộc về nơi đâu. Ngay từ những bước đầu chập chững, lạc lối và hoang mang như thế, Upzi đã luôn hiện diện, lặng lẽ đồng hành dẫn lối tôi trên hành trình ấy.`,
    avatar: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/thien_an.jpg`,
  },
];
